export const installCrosschainBuyFeature = async (): Promise<void> => {
  const composition = await import('./composition/install')
  await composition.installCrosschainBuyFeature()
}
